import React from 'react';
import PropTypes from 'prop-types';

import { useI18n } from '@hydra/common/components/i18n/i18nContext';
import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles(theme => ({
  root: {
    listStyle: 'none'
  },
  colorBox: {
    display: 'inline-block',
    width: 10,
    height: 10,
    verticalAlign: 'middle',
    marginRight: theme.spacing(0.75)
  }
}));

export const LegendWithPercentage = ({ payload }) => {
  const { numeral } = useI18n();
  const classes = useStyles();

  return (
    <ul className={classes.root}>
      {
        payload.map(entry => (
          <li key={entry.value}>
            <span className={classes.colorBox} style={{ background: entry.color }}>&nbsp;</span>
            {entry.value} ({numeral(entry.payload.percent).format('0%')})
          </li>
        ))
      }
    </ul>
  );
};

LegendWithPercentage.propTypes = {
  payload: PropTypes.arrayOf(
    PropTypes.shape({
      color: PropTypes.string,
      value: PropTypes.string,
      payload: PropTypes.shape({
        percent: PropTypes.number
      })
    })
  )
};

export default LegendWithPercentage;
